export default {"src":"/_next/static/media/iq.aa318b77.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};